// services/support/ticketMessageService.ts
import axios from "axios";
import { TicketMessage } from "../types/features/TicketMessage";
import { MAIN_API_URL } from "../config/api";

export const ticketMessageService = {
  async getMessages(ticketId: string): Promise<TicketMessage[]> {
    const response = await axios.get(`${MAIN_API_URL}/tickets/${ticketId}/messages`);
    return response.data;
  },

  async sendMessage(data: {
    ticket_id: string;
    author_type: 'client' | 'agent';
    author_id: string;
    message: string;
    is_internal: boolean;
  }): Promise<TicketMessage> {
    const response = await axios.post(`${MAIN_API_URL}/tickets/${data.ticket_id}/messages`, data);
    return response.data;
  }
};